import { render, staticRenderFns } from "./TermsAndConditionsUsa.vue?vue&type=template&id=16182f7c&scoped=true"
import script from "./TermsAndConditionsUsa.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsUsa.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsUsa.vue?vue&type=style&index=0&id=16182f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16182f7c",
  null
  
)

export default component.exports